import styled from 'styled-components';

import profilePhotoImage from '../../../assets/images/registration-complete-avatar-photo.png';
import { ProfileRating, ProfileSummaryCard } from '../../../shared/ui';
import {
  getTipCheckoutRatingFillLevels,
  TIP_CHECKOUT_PROFILE_RATING_VALUE,
} from '../model';

type TipCheckoutProfileCardProps = {
  avatarUrl?: string | null;
  goalText: string;
  isRatingVisible: boolean;
  profileName: string;
  progressLabel: string | null;
  progressPercent: number | null;
  ratingValueLabel: string;
};

const Avatar = styled.img`
  width: ${({ theme }) => theme.scale.px(70)};
  height: ${({ theme }) => theme.scale.px(70)};
  border-radius: 50%;
  object-fit: cover;
  display: block;
`;

export function TipCheckoutProfileCard({
  avatarUrl,
  goalText,
  isRatingVisible,
  profileName,
  progressLabel,
  progressPercent,
  ratingValueLabel,
}: TipCheckoutProfileCardProps) {
  const ratingFillLevels = getTipCheckoutRatingFillLevels(
    TIP_CHECKOUT_PROFILE_RATING_VALUE,
  );

  return (
    <ProfileSummaryCard
      avatar={
        <Avatar alt="" aria-hidden src={avatarUrl ?? profilePhotoImage} />
      }
      avatarSlotWidthPx={70}
      dataUi="tips-checkout-profile-card"
      goalText={goalText}
      profileName={profileName}
      progressLabel={progressLabel}
      progressPercent={progressPercent}
      progressTrackTone="neutral"
      ratingSlot={
        isRatingVisible ? (
          <ProfileRating
            fillLevels={ratingFillLevels}
            starSizePx={12}
            valueFontSizePx={14}
            valueFontWeight={600}
            valueLabel={ratingValueLabel}
          />
        ) : null
      }
    />
  );
}
